const actions = {
    GET_NOTAS_CIERRE_REQUEST: 'GET_NOTAS_CIERRE_REQUEST',
    GET_NOTAS_CIERRE_SUCCESS: 'GET_NOTAS_CIERRE_SUCCESS',

    CREATE_NOTAS_CIERRE_REQUEST: 'CREATE_NOTAS_CIERRE_REQUEST',
    CREATE_NOTAS_CIERRE_SUCCESS: 'CREATE_NOTAS_CIERRE_SUCCESS',

    EDIT_NOTAS_CIERRE_REQUEST: 'EDIT_NOTAS_CIERRE_REQUEST',
    EDIT_NOTAS_CIERRE_SUCCESS: 'EDIT_NOTAS_CIERRE_SUCCESS',

    DELETE_NOTAS_CIERRE_REQUEST: 'DELETE_NOTAS_CIERRE_REQUEST',
    DELETE_NOTAS_CIERRE_SUCCESS: 'DELETE_NOTAS_CIERRE_SUCCESS',

    SET_CURRENT_NOTA_CIERRE: 'SET_CURRENT_NOTA_CIERRE',

    initDataNotas: () => ({ type: actions.GET_NOTAS_CIERRE_REQUEST }),
    createNota: (data) => ({
        type: actions.CREATE_NOTAS_CIERRE_REQUEST,
        payload: data,
    }),
    editNota: data => ({
        type: actions.EDIT_NOTAS_CIERRE_REQUEST,
        payload: data
    }),
    deleteNota: id => ({
        type: actions.DELETE_NOTAS_CIERRE_REQUEST,
        payload: id
    }),
    setCurrentNota: nota => ({
        type: actions.SET_CURRENT_NOTA_CIERRE,
        payload: nota
    })
};
export default actions;